import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { Params, Router, UrlTree } from '@angular/router';
import { finalize } from 'rxjs';
import { LocalStorageKeysEnum } from '@cp/shared/data-access/shared/enums';
import { LogInTargetService } from '@cp/shared/data-access/http/login/log-in-target.service';

@Component({
  selector: 'cp-log-in-target',
  template:
    '<ui-progress-spinner *ngIf="lastLoggedIn$ | async"></ui-progress-spinner>',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogInTargetComponent {
  public lastLoggedIn$ = this._logInTargetService.lastLoggedIn$.pipe(
    finalize(() => this._redirect()),
  );

  constructor(
    private _router: Router,
    private _logInTargetService: LogInTargetService,
  ) {}

  private _redirect(): void {
    // Various tracker params to ignore
    const paramIdsToIgnore = [
      'dm_i',
      'dm_t',
      'fbclid',
      'gad',
      'gclid',
      'wbraid',
      'gbraid',
      'msclkid',
      'gtm_debug',
    ];
    const savedRedirectRoute = localStorage.getItem(
      LocalStorageKeysEnum.reRouteAfterLogIn,
    );
    let route: UrlTree = new UrlTree();

    if (savedRedirectRoute) {
      const tempRoute = this._router.parseUrl(savedRedirectRoute);
      const params = tempRoute.queryParamMap.keys
        .filter((key) => !paramIdsToIgnore.includes(key))
        .reduce(
          (acc, key) => ({ ...acc, [key]: tempRoute.queryParamMap.get(key) }),
          {} as Params,
        );

      route = new UrlTree(tempRoute.root, params, tempRoute.fragment);

      localStorage.removeItem(LocalStorageKeysEnum.reRouteAfterLogIn);
    }
    this._router.navigateByUrl(route).then();
  }
}
